import { useContext } from "react";

import { SuggestionsContext } from "@/components/suggestions/SuggestionsProvider";
import { getIsMobile } from "@/utils/getIsMobile";

import type { SuggestionsModel } from "@/models/SuggestionsModel";

export function useMenuSearchable(suggestions: SuggestionsModel, listId: string | null): boolean {
  const { suggestionsRenderPlace } = useContext(SuggestionsContext);

  return (
    !listId &&
    !getIsMobile() &&
    suggestionsRenderPlace === "tiptap" &&
    suggestions.pointerAnchor !== null
  );
}
